module.exports = __webpack_public_path__ + "static/tesla-hero-88c15d31ee1d4e00693d96468c5e8937.mp4";